
import React, { useRef, useEffect, useState } from "react";
import ApprovalTable from "../components/Rewards/ApplicationUse/ApprovalTable.js"
import CanceledTable from "../components/Rewards/ApplicationUse/CanceledTable.js"
import ApprovalOverview from "../components/Rewards/ApplicationUse/ApprovalOverview.js"
import RewardCodesOverview from "../components/Rewards/MaintenanceCodes/RewardCodesOverview.js"
import ApprovalRules from "../components/Rewards/ApplicationUse/ApprovalRules.js"
import NotificationAlert from "react-notification-alert";
import { Button } from "reactstrap";
import { NavLink, useParams } from "react-router-dom";

function Rewards(props) {
    const notificationAlertRef = useRef(null);
    const [appActive, setAppActive] = useState(true)
    const [trigger, setTrigger] = useState(true)
    const { request_type } = useParams()

    const notify = (place, message, type = 1, autoDismiss = 5) => {

        var options = {};
        options = {
            place: place,
            message: (
                <div>
                    {message}
                </div>
            ),
            type: type,
            icon: "tim-icons icon-bell-55",
            autoDismiss: autoDismiss
        };
        notificationAlertRef.current.notificationAlert(options);
    }

    useEffect(() => {
        setAppActive(request_type !== 'maintenance-codes')
        if (request_type !== 'maintenance-codes') {
            document.title = 'Application/Use - TMH Admin';
        } 
        else {
            document.title = 'Maintenance/Codes - TMH Admin';
        }
    }, [request_type])


    return (
        <div className="content">
            <div className="react-notification-alert-container">
                <NotificationAlert ref={notificationAlertRef} />
            </div>
            <div className="text-center mb-4">
                <NavLink to="/rewards/application-use">
                    <Button color={appActive ? "info" : "default"} className="btn btn-round">
                        Application/Use
                    </Button>
                </NavLink>
                
                <NavLink to="/rewards/maintenance-codes">
                    <Button color={appActive ? "default" : "info"} className="btn btn-round">
                        Maintenance/Codes
                    </Button>
                </NavLink>
            </div>
            {
                appActive ?
                    <>
                        <ApprovalOverview trigger={trigger} notify={notify} />
                        <ApprovalTable trigger={trigger} setTrigger={setTrigger} notify={notify} />
                        <CanceledTable trigger={trigger} setTrigger={setTrigger} notify={notify} />
                        <ApprovalRules trigger={trigger} setTrigger={setTrigger} notify={notify} />
                    </>
                    :
                    <>
                        <RewardCodesOverview notify={notify} />
                    </>
            }

        </div>
    );
}
export default Rewards;
